import { createApi, fetchBaseQuery, retry } from '@reduxjs/toolkit/query/react';
import config from '../../config';
import { keycloak } from '../../keycloak';
import { v4 as uuidv4 } from 'uuid';

import tidepoolApi from '../../core/api';

const fallbackSessionTrace = uuidv4();

export const RETRY_COUNT = 2;

export const getSessionTrace = () => {
  // To ensure that all requests from Blip have the same trace-session token, we inject
  // the trace-session token that is generated by `platform-client`. In the future, when
  // `platform-client` is no longer being used, we can remove this dependency and use
  // only a token generated by Blip
  return tidepoolApi?.tidepool?.getSessionTrace() || fallbackSessionTrace;
};

export const getSessionToken = () => {
  return keycloak?.token || '';
};

const apiHost = config.API_HOST;
const apiVersion = 'v1';

export const baseUrl = `${apiHost}/${apiVersion}/`;

export const prepareHeaders = (headers) => {
  headers.set('x-tidepool-trace-session', getSessionTrace());
  headers.set('x-tidepool-session-token', getSessionToken());

  return headers;
};

const baseQuery = fetchBaseQuery({
  baseUrl: baseUrl,
  prepareHeaders,
});

export const RTKQueryApi = createApi({
  reducerPath: 'api',
  tagTypes: ['MfaStatus'],
  baseQuery: retry(
    baseQuery,
    { maxRetries: RETRY_COUNT },
  ),
  refetchOnMountOrArgChange: true,
  endpoints: () => ({}),
});
